import { isEmpty } from 'lodash';

const getHostPromoListResponse = (response, previousResponse, page) => {
  const totalData = response?.data?.totalData ?? 0;
  const totalPage = response?.data?.totalPage ?? 0;
  const currentPage = response?.data?.currentPage ?? 1;

  let promotions = response?.data?.promotions ?? [];

  if (!isEmpty(previousResponse) && page !== 1) {
    promotions = [...previousResponse, ...promotions];
  }

  return {
    promotions,
    totalData,
    totalPage,
    currentPage,
  };
};

export default getHostPromoListResponse;
